import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Delete extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    team: PropTypes.object,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    phrase: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { team } = this.props
    const { phrase } = this.state
    return {
      ref: this.formRef,
      title: 't(Are you Sure?)',
      action: `/api/admin/platform/teams/${team.id}`,
      method: 'DELETE',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      cancelSvg: 'x',
      saveText: null,
      buttons: [
        {
          label: 'Delete',
          color: 'red',
          disabled: phrase !== team.subdomain,
          handler: this._handleSubmit
        }
      ],
      sections: [
        {
          instructions: (
            <div>
              <p>
                This will permanenty delete the <strong>{ team.subdomain }</strong> team
                and all its associated data. Are you sure you want to proceed?
              </p>
              <p>
                Please type <strong>{ team.subdomain }</strong> to confirm.
              </p>
            </div>
          ),
          fields: [
            { name: 'phrase', type: 'textfield', required: true }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange({ phrase }) {
    this.setState({ phrase })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess() {
    this.context.router.goBack()
    this.context.modal.close()
  }

}

export default Delete
